/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Flex,
  Link,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@tonic-one/react';
import isEqual from 'lodash/isEqual';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonTab from 'src/components/Common/ButtonTab';
import { TitleLabel } from 'src/components/Common/FormComponent';
import NotifyAdmin from 'src/components/FilterNotification/NotifyAdmin';
import NotifyUser from 'src/components/FilterNotification/NotifyUser';
import {
  EnableDisableStatus,
  ExchangeOnlinePolicyItem,
} from 'src/pages/Policy/utils/types';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
// import { wtpActionDataSelector } from './store';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import { PolicyModeEnum, PolicyTypeEnum } from '@Policy/utils/constants';
import {
  wtpActionDataSelector,
  wtpAdvancedOptionConfigSelector,
  wtpAdvancedSettingsSelector,
} from '@Policy/store/filters/webReputation';
import Actions from '../../Components/Actions';
import AdvancedOptionModal from '../../Components/AdvancedOptionModal';
import AdvancedSettingsModal from '../../Components/AdvancedSettingsModal';
export const WtpAction = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state from store
  const actionData = contextSelector(wtpActionDataSelector, isEqual);
  useWhyDidYouUpdate('WtpAction', { actionData });
  const policySelector = templateSelector(contextStore);
  const policyMode = policySelector((s) => s.policyMode);
  return (
    <Actions
      actionData={actionData}
      disabledAll={policyMode === PolicyModeEnum.DefaultMonitorPolicy}
    />
  );
};
export const WtpAdvancedOption = ({
  replaceFileNameShow,
  availableTokenShow,
}: {
  availableTokenShow: boolean;
  replaceFileNameShow: boolean;
}) => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const advancedOptionConfig = contextSelector(
    wtpAdvancedOptionConfigSelector,
    isEqual
  );

  // get action from store
  const setWtpState = contextSelector((s) => s.setWtpState);
  // advanced option
  const [isVisible, setIsVisible] = React.useState(false);
  const handleAdvancedOptionClose = React.useCallback(() => {
    setIsVisible(false);
  }, []);
  const policyType = policySelector((s) => s.policyType);
  const handleAdvancedOptionSave = React.useCallback(
    ({ replaceText }: { replaceText: string }) => {
      setWtpState({
        wtpReplacementText: replaceText,
      });
      // close the modal
      setIsVisible(false);
    },
    []
  );
  useWhyDidYouUpdate('Web Reputation WtpAdvancedOption', {
    advancedOptionConfig,
    isVisible,
  });
  return (
    <>
      <Link mr="24px" onClick={() => setIsVisible(!isVisible)}>
        {t('policy.action.advanced.title')}
      </Link>
      <AdvancedOptionModal
        replacementTextDesc={
          [
            PolicyTypeEnum.SharePoint,
            PolicyTypeEnum.OneDrive,
            PolicyTypeEnum.Box,
            PolicyTypeEnum.Dropbox,
            PolicyTypeEnum.GoogleDrive,
            PolicyTypeEnum.Teams,
          ].includes(policyType)
            ? t('policy.action.replaceAction.quarantineOrDelete.desc')
            : t('policy.action.replaceAction.desc')
        }
        availableTokenShow={availableTokenShow}
        replaceFileNameShow={replaceFileNameShow}
        isVisible={isVisible}
        onClose={handleAdvancedOptionClose}
        config={advancedOptionConfig}
        saveConfig={handleAdvancedOptionSave}
      />
    </>
  );
};

export const WtpAdvancedSettings4Files = ({
  availableTokenShow,
}: {
  availableTokenShow: boolean;
}) => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const advancedSettingsConfig = contextSelector(
    wtpAdvancedSettingsSelector,
    isEqual
  );
  const setWtpState = contextSelector((s) => s.setWtpState);
  // local state
  const [isVisible, setIsVisible] = React.useState<boolean>(false);
  // advanced optino
  const handleAdvancedSettings4FilesClose = useCallback(() => {
    setIsVisible(false);
  }, []);
  const handleAdvancedSettingsSave = useCallback(
    (config: {
      secondActionEnabled: number;
      secondActionType: number;
      replaceFileTagContent: string;
      replaceText: string;
      firstActionEnabled?: number;
      firstActionType?: number;
      firstActionNotifyType?: EnableDisableStatus;
    }) => {
      // save config
      setWtpState({
        wtpFileTagEnabled: config.firstActionEnabled,
        wtpFileAction: config.firstActionType,
        wtpFileActionNotifyType: config.firstActionNotifyType,
        wtpSecondActionEnabled: config.secondActionEnabled,
        wtpSecondActionType: config.secondActionType,
        wtpFileTagContent: config.replaceFileTagContent,
        wtpReplacementText: config.replaceText,
      });
      // close the modal
      setIsVisible(false);
    },
    []
  );
  useWhyDidYouUpdate('FileBlocking FbAdvancedSettings4Files', {
    advancedSettingsConfig,
    isVisible,
  });
  return (
    <>
      <Link mr="24px" onClick={() => setIsVisible(!isVisible)}>
        {t('policy.action.advancedSettings.title')}
      </Link>
      <AdvancedSettingsModal
        availableTokenShow={availableTokenShow}
        isVisible={isVisible}
        onClose={handleAdvancedSettings4FilesClose}
        config={advancedSettingsConfig}
        saveConfig={handleAdvancedSettingsSave}
        isExtraAction={true}
      />
    </>
  );
};

export const WtpNotification = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const ntfEnableNotifyRecipient = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfEnableNotifyRecipient
  );
  const ntfInternalRecipientSubject = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfInternalRecipientSubject
  );
  const ntfInternalRecipientMessage = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfInternalRecipientMessage
  );
  const ntfEnableNotifyAdmin = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfEnableNotifyAdmin
  );
  const ntfToAccount = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfToAccount
  );
  const ntfAdminSubject = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfAdminSubject
  );
  const ntfAdminMessage = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfAdminMessage
  );
  const ntfAdminNotifySettingType = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfAdminNotifySettingType
  );
  const ntfAdminIntervalNum = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfAdminIntervalNum
  );
  const ntfAdminIntervalType = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfAdminIntervalType
  );
  const ntfAdminOccurenceNum = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfAdminOccurenceNum
  );
  const ntfRecipientGroupId = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfRecipientGroupId
  );
  const ntfRecipientGroupEnabled = policySelector(
    (s) => s.tmWebthreatprotections.notification.ntfRecipientGroupEnabled
  );
  const recipientGroups = contextSelector((s) => s.recipientGroups);
  // get action from store
  const setWtpNtfState = contextSelector((s) => s.setWtpNtfState);
  // local state
  // notify user
  const handleNtfEnableNotifyRecipientChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setWtpNtfState({
        ntfEnableNotifyRecipient: e.target.checked ? 1 : 0,
      });
    },
    []
  );

  const handleNtfInternalRecipientSubjectChange = React.useCallback(
    (subject: string) =>
      setWtpNtfState({ ntfInternalRecipientSubject: subject }),
    []
  );
  const handleNtfInternalRecipientMessageChange = React.useCallback(
    (message: string) =>
      setWtpNtfState({ ntfInternalRecipientMessage: message }),
    []
  );
  // notify admin
  const handleNtfEnableNotifyAdmin = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setWtpNtfState({ ntfEnableNotifyAdmin: e.target.checked ? 1 : 0 });
    },
    []
  );
  const handleNtfToAccountChange = React.useCallback(
    (toAccount: string) => setWtpNtfState({ ntfToAccount: toAccount }),
    []
  );
  const handleNtfAdminSubjectChange = React.useCallback(
    (subject: string) => setWtpNtfState({ ntfAdminSubject: subject }),
    []
  );
  const handleNtfAdminMessageChange = React.useCallback(
    (message: string) => setWtpNtfState({ ntfAdminMessage: message }),
    []
  );
  const handleNtfAdminNotifySettingTypeChange = React.useCallback(
    (notifySettingType: number) =>
      setWtpNtfState({ ntfAdminNotifySettingType: notifySettingType }),
    []
  );
  const handleNtfAdminIntervalNumChange = React.useCallback(
    (intervalNum: number) =>
      setWtpNtfState({ ntfAdminIntervalNum: intervalNum }),
    []
  );
  const handleNtfAdminIntervalTypeChange = React.useCallback(
    (intervalType: number) =>
      setWtpNtfState({ ntfAdminIntervalType: intervalType }),
    []
  );
  const handleNtfAdminOccurenceNumChange = React.useCallback(
    (occurenceNum: number) =>
      setWtpNtfState({ ntfAdminOccurenceNum: occurenceNum }),
    []
  );
  const handleNtfRecipientGroupIdChange = React.useCallback(
    (recipientGroupId: number) => {
      setWtpNtfState({ ntfRecipientGroupId: recipientGroupId });
    },
    []
  );
  const handleNtfRecipientGroupEnabledChange = React.useCallback(
    (enabled: EnableDisableStatus) => {
      setWtpNtfState({ ntfRecipientGroupEnabled: enabled });
    },
    []
  );
  useWhyDidYouUpdate('WtpNotification', {
    ntfEnableNotifyRecipient,
    ntfInternalRecipientSubject,
    ntfInternalRecipientMessage,
    ntfEnableNotifyAdmin,
    ntfToAccount,
    ntfAdminSubject,
    ntfAdminMessage,
    ntfAdminNotifySettingType,
    ntfAdminIntervalNum,
    ntfAdminIntervalType,
    ntfAdminOccurenceNum,
    ntfRecipientGroupId,
    ntfRecipientGroupEnabled,
    recipientGroups,
  });
  return (
    <Tabs mt="24px">
      <TabList>
        <ButtonTab>{t('policy.notification.admin')}</ButtonTab>
        <ButtonTab>{t('policy.notification.user')}</ButtonTab>
      </TabList>
      <TabPanels py="24px">
        <TabPanel>
          <NotifyAdmin
            status={ntfEnableNotifyAdmin}
            toAccount={ntfToAccount}
            notifySettingType={ntfAdminNotifySettingType}
            subject={ntfAdminSubject}
            message={ntfAdminMessage}
            intervalNum={ntfAdminIntervalNum}
            intervalType={ntfAdminIntervalType}
            occurenceNum={ntfAdminOccurenceNum}
            recipientGroupId={ntfRecipientGroupId}
            recipientGroups={recipientGroups}
            recipientGroupEnabled={ntfRecipientGroupEnabled}
            setStatus={handleNtfEnableNotifyAdmin}
            setToAccount={handleNtfToAccountChange}
            setNotifySettingType={handleNtfAdminNotifySettingTypeChange}
            setSubject={handleNtfAdminSubjectChange}
            setMessage={handleNtfAdminMessageChange}
            setIntervalNum={handleNtfAdminIntervalNumChange}
            setIntervalType={handleNtfAdminIntervalTypeChange}
            setOccurenceNum={handleNtfAdminOccurenceNumChange}
            setRecipientGroupId={handleNtfRecipientGroupIdChange}
            setRecipientGroupEnabled={handleNtfRecipientGroupEnabledChange}
          />
        </TabPanel>
        <TabPanel>
          <NotifyUser
            status={ntfEnableNotifyRecipient}
            subject={ntfInternalRecipientSubject}
            message={ntfInternalRecipientMessage}
            setStatus={handleNtfEnableNotifyRecipientChange}
            setSubject={handleNtfInternalRecipientSubjectChange}
            setMessage={handleNtfInternalRecipientMessageChange}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

function ActionNotification({
  advancedOptionShow = false,
  availableTokenShow = false,
  replaceFileNameShow = false,
  advancedSettings4FilesShow = false,
}: {
  advancedOptionShow?: boolean;
  availableTokenShow?: boolean;
  replaceFileNameShow?: boolean;
  advancedSettings4FilesShow?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Box ml="1px" mt="4x" width="100%">
      <Flex direction="column">
        <TitleLabel title={t('policy.action')} mb="6x" />
        <WtpAction />
        {advancedOptionShow ? (
          <Flex mb="6x" mt="4x">
            <WtpAdvancedOption
              availableTokenShow={availableTokenShow}
              replaceFileNameShow={replaceFileNameShow}
            />
          </Flex>
        ) : null}
        {advancedSettings4FilesShow ? (
          <Flex mb="6x" mt="4x">
            <WtpAdvancedSettings4Files
              availableTokenShow={availableTokenShow}
            />
          </Flex>
        ) : null}
        <TitleLabel title={t('policy.notification')} mt="6x" />
        <WtpNotification />
      </Flex>
    </Box>
  );
}

export default React.memo(ActionNotification);
